import React from 'react'
import { Play, Pause, SkipForward, SkipBack, Plus, Square, VolumeX, Volume2 } from 'lucide-react'
import { Button } from '../ui/button'

const EnVivoControles = ({
  iniciado,
  pausado,
  terminado,
  muted,
  onIniciar,
  onPausar,
  onReanudar,
  onSaltar,
  onAnterior,
  onExtender,
  onTerminar,
  onToggleMute
}) => {
  if (!iniciado) {
    return (
      <div className="flex flex-col items-center gap-3">
        <Button size="lg" className="h-16 w-48 text-lg" onClick={onIniciar}>
          <Play className="h-6 w-6 mr-2" />
          Iniciar
        </Button>
        <Button variant="ghost" size="sm" onClick={onToggleMute}>
          {muted ? <VolumeX className="h-4 w-4 mr-1" /> : <Volume2 className="h-4 w-4 mr-1" />}
          {muted ? 'Silenciado' : 'Sonido'}
        </Button>
      </div>
    )
  }

  if (terminado) return null

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-3 gap-2">
        {pausado ? (
          <Button size="lg" onClick={onReanudar}>
            <Play className="h-4 w-4 mr-1" />
            Reanudar
          </Button>
        ) : (
          <Button size="lg" variant="secondary" onClick={onPausar}>
            <Pause className="h-4 w-4 mr-1" />
            Pausar
          </Button>
        )}
        <Button size="lg" variant="outline" onClick={onSaltar}>
          <SkipForward className="h-4 w-4 mr-1" />
          Saltar
        </Button>
        <Button size="lg" variant="outline" onClick={() => onExtender(60)}>
          <Plus className="h-4 w-4 mr-1" />
          1 min
        </Button>
      </div>
      <div className="grid grid-cols-3 gap-2">
        <Button variant="outline" onClick={onAnterior}>
          <SkipBack className="h-4 w-4 mr-1" />
          Anterior
        </Button>
        <Button variant="outline" onClick={() => onExtender(300)}>
          <Plus className="h-4 w-4 mr-1" />
          5 min
        </Button>
        <Button variant="destructive" onClick={onTerminar}>
          <Square className="h-4 w-4 mr-1" />
          Terminar
        </Button>
      </div>
      <div className="flex justify-center">
        <Button variant="ghost" size="sm" onClick={onToggleMute}>
          {muted ? <VolumeX className="h-4 w-4 mr-1" /> : <Volume2 className="h-4 w-4 mr-1" />}
          {muted ? 'Silenciado' : 'Sonido'}
        </Button>
      </div>
    </div>
  )
}

export default EnVivoControles
